export const AGENT_QUESTIONNAIRE_DATA_REQUEST =
  'AGENT_QUESTIONNAIRE_DATA_REQUEST';
export const AGENT_QUESTIONNAIRE_DATA_SUCCESS =
  'AGENT_QUESTIONNAIRE_DATA_SUCCESS';
export const AGENT_QUESTIONNAIRE_DATA_FAIL = 'AGENT_QUESTIONNAIRE_DATA_FAIL';
